class Collection {
    constructor() {
        (this.selectors = {
            section: ".facest-filters-section",
            toolbar: ".m-collection-toolbar",
            cols: [".m-toolbar--column-switcher button"],
            productContainer: "[data-product-container]",
            loadMoreBtn: "[data-load-more]",
            sidebar: ".m-sidebar",
            sidebarContent: ".m-sidebar--content",
            openSidebar: ".m-sidebar--open",
            closeSidebar: ".m-sidebar--close",
            filtersWrapper: ".m-filter--wrapper",
        }),
            (this.mobileSortingSelectors = {
                openSorting: ".m-sortby--open",
                closeSorting: ".m-sortby-mobile--close",
                sortingWrapper: ".m-sortby-mobile--wrapper",
                sortingList: ".m-sortby-mobile--content",
            }),
            (this.sectionId = ""),
            (this.isDesignMode = MinimogSettings.design_mode),
            (this.currentPage = 1),
            this.paginationType,
            this.totalPages,
            this.totalProducts,
            this.infiniteLoadingObserver,
            this.showColSwitchers,
            this.cachedCol,
            this.initialCol,
            this.activeCol,
            (this.STORAGE_KEY = "gridColumnViews"),
            (this.MAX_COL_BY_SCREEN_SIZE = { mobile: 4, tablet: 4, desktop: 5 }),
            this.enableFilters,
            this.enableSorting,
            this.filtersType,
            this.filtersPosition,
            this.accordions,
            this.prefetchedPages = {};
            this.prefetchingPages = {};
            this.restoredCurrentPage = null;
            this.isLoadingMore = false;
            this.prefetchObserver = null;
            this.restoredCurrentPage = null;
            (this.sideEffectEventsAdded = !1);
    }
    init = () => {
        (this.domNodes = queryDomNodes(this.selectors)),
            (this.mbSortingNodes = queryDomNodes(this.mobileSortingSelectors)),
            this.setData(),
            this.initGridView(),
            this.initFilters(),
            this.initMobileSorting(),
            this.initProducts(),
            (this.sideEffectEventsAdded = !0),
            MinimogEvents.subscribe("ON_PRODUCT_LIST_UPDATED", () => refreshProductReview()),
            this.handleStickyToolbar(),
            document.addEventListener("matchMobile", () => this.handleStickyToolbar()),
            document.addEventListener("unmatchMobile", () => this.handleStickyToolbar());
            window.__collectionInstance = this;
    };
    setData = () => {
        const { section: t, productContainer: e } = this.domNodes;

        this.sectionId = t.dataset.sectionId;
        this.paginationType = t.dataset.paginationType;
        this.totalPages = e ? Number(e.dataset.totalPages) || 1 : 1;
        this.view = t.dataset.view;
        this.activeCol = null;
        this.currentPage = this.getRestoredCurrentPage() || 1;
        if (this.currentPage === 1) {
            try {
                sessionStorage.removeItem(
                    'collection-current-page:' + window.location.pathname + window.location.search
                );
            } catch (e) {}
        }

        this.initialCol = Number(t.dataset.initialColumn);
        this.cachedCol = Number(window.localStorage.getItem(this.STORAGE_KEY)) || this.initialCol;
        this.showColSwitchers = "true" === t.dataset.showColSwitchers;
        this.enableFilters = "true" === t.dataset.enableFilters;
        this.enableSorting = "true" === t.dataset.enableSorting;
        this.filtersType = t.dataset.filtersType;
        this.filtersPosition = t.dataset.filtersPosition;

        window.__collectionCurrentPage = this.currentPage;

        try {
            sessionStorage.setItem(
                'collection-current-page:' + window.location.pathname + window.location.search,
                String(this.currentPage)
            );
        } catch (e) {}
    };
    getHistoryStorageKey = () => {
        return "collection-history-state:" + window.location.pathname + window.location.search;
    };
    
    getRestoredCurrentPage = () => {
        try {
            var pendingRestoreKey =
                'collection-history-state:pending:' + window.location.pathname + window.location.search;

            var hasPendingRestore = sessionStorage.getItem(pendingRestoreKey) === '1';

            var isBackForward = false;
            try {
                var navEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
                if (navEntries && navEntries.length) {
                    isBackForward = navEntries[0].type === 'back_forward';
                }
            } catch (e) {}

            // console.log('[getRestoredCurrentPage] START', {
            //     hasPendingRestore: hasPendingRestore,
            //     isBackForward: isBackForward
            // });

            if (!hasPendingRestore && !isBackForward) {
                //console.log('[getRestoredCurrentPage] no restore context, returning null');
                return null;
            }

            var key = 'collection-current-page:' + window.location.pathname + window.location.search;

            var directPage = sessionStorage.getItem(key);
            //console.log('[getRestoredCurrentPage] directPage (raw):', directPage);

            if (directPage) {
                var parsedDirectPage = parseInt(directPage, 10);
                //console.log('[getRestoredCurrentPage] parsedDirectPage:', parsedDirectPage);

                if (!isNaN(parsedDirectPage) && parsedDirectPage > 0) {
                    //console.log('[getRestoredCurrentPage] ✅ using directPage');
                    return parsedDirectPage;
                }
            }

            var historyState =
                history.state && history.state.collectionState
                    ? history.state.collectionState
                    : null;

            //console.log('[getRestoredCurrentPage] historyState:', historyState);

            if (historyState && historyState.currentPage) {
                var historyPage = parseInt(historyState.currentPage, 10);
                //console.log('[getRestoredCurrentPage] parsed historyPage:', historyPage);

                if (!isNaN(historyPage) && historyPage > 0) {
                    //console.log('[getRestoredCurrentPage] ✅ using historyState');
                    return historyPage;
                }
            }

            var historyKey = this.getHistoryStorageKey();
            var raw = sessionStorage.getItem(historyKey);

            //console.log('[getRestoredCurrentPage] raw history storage:', raw);

            if (raw) {
                var parsed = JSON.parse(raw);
                //console.log('[getRestoredCurrentPage] parsed history storage:', parsed);

                if (parsed && parsed.currentPage) {
                    var savedPage = parseInt(parsed.currentPage, 10);
                    //console.log('[getRestoredCurrentPage] parsed savedPage:', savedPage);

                    if (!isNaN(savedPage) && savedPage > 0) {
                        //console.log('[getRestoredCurrentPage] ✅ using session history');
                        return savedPage;
                    }
                }
            }

            //console.log('[getRestoredCurrentPage] returning null');
            return null;
        } catch (e) {
            console.error('[getRestoredCurrentPage] ERROR:', e);
            return null;
        }
    };
    initGridView = () => {
        $("#CollectionProductGrid").css("opacity", "1");
        $(".m-collection-products").css("opacity", "1");
        this.toggleView(this.isDesignMode ? this.initialCol : this.cachedCol),
            this.updateViewByScreen(),
            addEventDelegate({
                selector: this.selectors.cols[0],
                context: this.domNodes.toolbar,
                handler: (t, e) => this.toggleView(Number(e.dataset.column)),
            }),
            this.initLoadMore(),
            this.initPrefetchObserver(),
            this.sideEffectEventsAdded || window.addEventListener("resize", debounce(this.updateViewByScreen, 500));
    };
    initFilters = () => {
        if (!this.enableFilters) return;
        const { sidebar: t, openSidebar: e, closeSidebar: i } = this.domNodes;
        window.requestAnimationFrame(this.initAccordions),
            e.addEventListener("click", this.openSidebarFilter),
            i.addEventListener("click", this.closeSidebarFilter),
            t.addEventListener("click", (e) => e.target === t && this.closeSidebarFilter());
    };

    initMobileSorting = () => {
        if (!this.enableSorting) return;

        const { openSorting, closeSorting, sortingWrapper } = this.mbSortingNodes || {};

        // console.log('[Collection.initMobileSorting] nodes', {
        //     openSorting,
        //     closeSorting,
        //     sortingWrapper
        // });

        if (!openSorting || !closeSorting || !sortingWrapper) {
            console.warn('[Collection.initMobileSorting] skipped: missing node(s)');
            return;
        }

        openSorting.addEventListener("click", this.openMobileSorting);
        closeSorting.addEventListener("click", this.closeMobileSorting);
        sortingWrapper.addEventListener("click", (event) => {
            if (event.target === sortingWrapper) this.closeMobileSorting();
        });
    };
    openMobileSorting = () => {
        const { sortingWrapper, sortingList } = this.mbSortingNodes || {};
        if (!sortingWrapper || !sortingList) return;

        sortingWrapper.style.display = "block";

        window.requestAnimationFrame(() => {
            sortingWrapper.style.setProperty("--m-bg-opacity", "0.5");
            sortingList.style.setProperty("--m-translate-y", "0");
        });
    };

    closeMobileSorting = () => {
        const { sortingWrapper, sortingList } = this.mbSortingNodes || {};
        if (!sortingWrapper || !sortingList) return;

        sortingWrapper.style.setProperty("--m-bg-opacity", "0");
        sortingList.style.setProperty("--m-translate-y", "100%");
        setTimeout(() => sortingWrapper.style.setProperty("display", "none"), 300);
    };
    initAccordions = () => {
        this.accordions && this.accordions.destroy();
        const { filtersWrapper: t } = this.domNodes;
        t.classList.remove("acc-initialized"),
            (this.accordions = new MinimogLibs.Accordion(t, {
                presetContentHeight: window.innerWidth > 1280 && "fixed" !== this.filtersPosition,
                callback: () => t.style.setProperty("opacity", "1"),
            }));
    };
    openSidebarFilter = () => {
        const { sidebar: t, sidebarContent: e, section: i } = this.domNodes;
        (t.style.display = "block"),
            window.requestAnimationFrame(() => {
                t.style.setProperty("--m-bg-opacity", "0.5"),
                    e.style.setProperty("--m-translate-x", "0"),
                    this.accordions && this.accordions.setContentHeight();
            }),
            i.classList.add("sidebar-open");
    };
    closeSidebarFilter = () => {
        const { sidebar: t, sidebarContent: e, section: i } = this.domNodes;
        i.classList.remove("sidebar-open"),
            (window.innerWidth < 1280 || "fixed" === t.dataset.type) &&
                (e.style.setProperty("--m-translate-x", "-100%"),
                t.style.removeProperty("--m-bg-opacity"),
                setTimeout(() => t.style.removeProperty("display"), 300));
    };
    toggleView = (t) => {
        if (!t || "search" === this.view) return;
        const { cols: e, productContainer: i } = this.domNodes;
        if (!i) return;
        const s = i.querySelectorAll("responsive-image");
        s &&
            s.length > 0 &&
            s.forEach((t) => {
                t.disconnectedCallback(), t.connectedCallback();
            });
        const o = this.activeCol || this.initialCol;
        this.showColSwitchers && (e[o - 1].classList.remove("active"), e[t - 1].classList.add("active")),
            i.classList.remove(`m-cols-${o}`),
            i.classList.add(`m-cols-${t}`),
            window.localStorage.setItem(this.STORAGE_KEY, t),
            (this.activeCol = t);
    };
    updateViewByScreen = () => {
        if (1 === this.activeCol) return;
        const t = this.getDeviceByScreenSize(),
            e = this.MAX_COL_BY_SCREEN_SIZE[t];
        e < this.activeCol && this.toggleView(e);
    };
    getDeviceByScreenSize = () =>
        window.innerWidth < 768 ? "mobile" : window.innerWidth < 1024 ? "tablet" : "desktop";
    initLoadMore = () => {
        if ("paginate" === this.paginationType || this.totalPages <= 1 || "search" === this.view) return;
        const { loadMoreBtn: t } = this.domNodes;
        t.addEventListener("click", this.loadMoreProducts),
            "infinite" === this.paginationType &&
                ((this.infiniteLoadingObserver = new IntersectionObserver(
                    (t) => {
                        t.forEach((t) => {
                            1 === t.intersectionRatio && this.loadMoreProducts();
                        });
                    },
                    { threshold: 1 }
                )),
                this.infiniteLoadingObserver.observe(t));
    };
    loadMoreProducts = () => {
        const t = this.currentPage + 1;
        if (t > this.totalPages) return;

        const { productContainer: e, loadMoreBtn: i } = this.domNodes;

        if (this.isLoadingMore) return;
        this.isLoadingMore = true;

        this.toggleLoading(!0);

        this.getPageHtml(t)
            .then((responseHtml) => {
                var newContainer = responseHtml.querySelector('[data-product-container]');
                if (!newContainer) return;

                var existingItems = Array.from(e.querySelectorAll('.m-product-item'));
                var maxOrder = existingItems.reduce(function (max, item) {
                    var value = parseInt(item.style.order || 0, 10);
                    return Math.max(max, isNaN(value) ? 0 : value);
                }, 0);

                var appendedItems = [];
                var fragment = document.createDocumentFragment();

                Array.from(newContainer.children).forEach((item, index) => {
                    if (!item.classList.contains('m-product-item')) return;

                    item.style.order = maxOrder + index + 1;
                    fragment.appendChild(item);
                    appendedItems.push(item);
                });

                e.appendChild(fragment);

                for (var x = 0; x < appendedItems.length; x++) {
                    if (window.refreshCollectionCarousels) {
                        window.refreshCollectionCarousels(appendedItems[x]);
                    }

                    if (typeof initHalfSizeSoldOut === 'function') {
                        initHalfSizeSoldOut(appendedItems[x]);
                    }
                }

                this.initProducts();
            })
            .catch((t) => {})
            .finally(() => {
                MinimogEvents.emit("ON_PRODUCT_LIST_UPDATED");
                this.toggleLoading(!1);
                this.currentPage = t;
                window.__collectionCurrentPage = this.currentPage;
                this.isLoadingMore = false;

                try {
                    sessionStorage.setItem(
                        'collection-current-page:' + window.location.pathname + window.location.search,
                        String(this.currentPage)
                    );
                } catch (e) {}

                if (t >= this.totalPages) {
                    i.parentNode.remove();
                    if (this.infiniteLoadingObserver) {
                        this.infiniteLoadingObserver.unobserve(i);
                    }
                } else {
                    this.prefetchPage(t + 1);
                }
            });
    };
    initPrefetchObserver = () => {
        const { loadMoreBtn: t } = this.domNodes;
        if (!t) return;

        this.prefetchObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                this.scheduleNextPrefetch();
                this.prefetchObserver.unobserve(entry.target);
            });
        }, { rootMargin: '600px 0px', threshold: 0 });

        this.prefetchObserver.observe(t);
    };
    initProducts = () => {
        MinimogTheme.CompareProduct && MinimogTheme.CompareProduct.setCompareButtonsState(),
            MinimogTheme.Wishlist && MinimogTheme.Wishlist.setWishlistButtonsState();
    };
    toggleLoading = (t) => {
        const { loadMoreBtn: e } = this.domNodes;
        if (e) {
            const i = t ? "add" : "remove";
            e.classList[i]("m-spinner-loading");
        }
    };
    handleStickyToolbar() {
        const t = this.domNodes.toolbar,
            e = t && t.offsetTop;
        let i = 0;
        window.addEventListener("scroll", () => {
            if (MinimogTheme.config.mqlMobile) {
                const s = window.scrollY;
                if (s <= e) return void t.classList.remove("scroll-up", "m-collection-toolbar--sticky");
                t.classList.add("m-collection-toolbar--sticky"),
                    s > t.offsetHeight + e && s > i && !t.classList.contains("scroll-down")
                        ? (t.classList.remove("scroll-up"), t.classList.add("scroll-down"))
                        : s < i &&
                          t.classList.contains("scroll-down") &&
                          (t.classList.remove("scroll-down"), t.classList.add("scroll-up")),
                    (i = s);
            } else t.classList.remove("scroll-up", "m-collection-toolbar--sticky", "scroll-down");
        });
    };
    prefetchPage = (page) => {
    if (!page || page > this.totalPages) return;
    if (this.prefetchedPages[page]) return;
    if (this.prefetchingPages[page]) return;

    this.prefetchingPages[page] = true;

    fetchSection(this.sectionId, { fromCache: !0, params: { page: page } })
        .then((responseHtml) => {
            this.prefetchedPages[page] = responseHtml;
        })
        .catch(() => {})
        .finally(() => {
            delete this.prefetchingPages[page];
        });
    };

    getPageHtml = (page) => {
        if (this.prefetchedPages[page]) {
            var html = this.prefetchedPages[page];
            delete this.prefetchedPages[page];
            return Promise.resolve(html);
        }

        return fetchSection(this.sectionId, { fromCache: !0, params: { page: page } });
    };

    scheduleNextPrefetch = () => {
        var nextPage = this.currentPage + 1;
        if (nextPage > this.totalPages) return;
        this.prefetchPage(nextPage);
    };
}
